import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import {
  BREAKPOINT,
  BreakpointService,
  FacetList,
  FacetService,
  ProductFacetNavigationComponent
} from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FADE_IN_CONTENT_BY_HEIGHT_OPACITY } from '@app/core/constants/animations.constant';

@Component({
  selector: 'dp-product-facet-navigation',
  templateUrl: './product-facet-navigation.component.html',
  styleUrls: ['./product-facet-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY],
  standalone: false
})
export class DpProductFacetNavigationComponent extends ProductFacetNavigationComponent {
  exceeded = signal<boolean>(false);
  hasShowAllFacets = signal<boolean>(false);
  readonly countOfActiveFacets$: Observable<number> = inject(FacetService).facetList$.pipe(
    map(
      (facets: FacetList) => facets.activeFacets?.filter((facet) => facet?.facetCode !== 'isRelatedPart')?.length ?? 0
    )
  );
  protected CLOSE_DELAY = 0;

  constructor(breakpointService: BreakpointService) {
    super(breakpointService);
    breakpointService
      .isUp(BREAKPOINT.lg)
      .pipe(takeUntilDestroyed())
      .subscribe((value) => {
        this.open$.next(value);
      });
  }

  get hasTrigger(): boolean {
    return this.trigger?.nativeElement.offsetParent !== null;
  }

  launch(): void {
    this.open$.next(!this.open$.value);
  }

  onExceededFilters(value: boolean): void {
    this.exceeded.update(() => value);
  }

  onToggleVisibleFacets(): void {
    this.hasShowAllFacets.update((state) => !state);
  }
}
